import { Box, Button, Container, Typography } from '@mui/material';
import { useRouteError, useNavigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

export const RouteError = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  let title = 'Something went wrong';
  let description = 'An unexpected error occurred. Please try again.';

  return (
    <Container maxWidth='sm'>
      <Box
        sx={{
          minHeight: '70vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Typography variant='h3' gutterBottom>
          {title}
        </Typography>

        <Typography variant='body1' sx={{ mb: 4, color: 'text.secondary' }}>
          {description}
        </Typography>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button variant='contained' onClick={() => navigate(0)}>
            Reload
          </Button>

          <Button variant='outlined' onClick={() => navigate('/')}>
            Go Home
          </Button>
        </Box>
      </Box>
    </Container>
  );
};
